<template>
  <svg viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.38 2.015C24.08 1.13 23.24 0.5 22.25 0.5H5.75C4.76 0.5 3.935 1.13 3.62 2.015L0.5 11V23C0.5 23.825 1.175 24.5 2 24.5H3.5C4.325 24.5 5 23.825 5 23V21.5H23V23C23 23.825 23.675 24.5 24.5 24.5H26C26.825 24.5 27.5 23.825 27.5 23V11L24.38 2.015ZM7.25 17C6.005 17 5 15.995 5 14.75C5 13.505 6.005 12.5 7.25 12.5C8.495 12.5 9.5 13.505 9.5 14.75C9.5 15.995 8.495 17 7.25 17ZM20.75 17C19.505 17 18.5 15.995 18.5 14.75C18.5 13.505 19.505 12.5 20.75 12.5C21.995 12.5 23 13.505 23 14.75C23 15.995 21.995 17 20.75 17ZM4.715 8L6.275 3.5H21.71L23.27 8H4.715Z"
      fill="currentColor"
    />
  </svg>
</template>
